import React, { ReactElement, useState } from "react";

import { Container, Question, Answer, QuestionContainer, AnswerContainer } from "./styles";

import CollapsibleDiv from "~/components/CollapsibleDiv";
import { ArrowDownIcon } from "~/components/icons/Arrow";
import Spacer, { Axis } from "~/components/Spacer";

interface Props {
  question: string;
  answer: ReactElement;
  checkIfCollapsed: (collapsed: boolean) => void;
}

export default function QuestionBox({ question, answer, checkIfCollapsed }: Props) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapsed = () => {
    setIsCollapsed(!isCollapsed);
    checkIfCollapsed(!isCollapsed);
  };

  return (
    <Container>
      <QuestionContainer>
        <ArrowDownIcon
          onClick={toggleCollapsed}
          color={"#000"}
          style={{
            position: "absolute",
            right: 0,
            cursor: "pointer",
            transition: "all .2s ease",
            transform: isCollapsed ? "rotate(0deg)" : "rotate(180deg)",
          }}
        />

        <Question>{question}</Question>
      </QuestionContainer>
      <AnswerContainer>
        <CollapsibleDiv collapsed={isCollapsed}>
          <Spacer axis={Axis.VERTICAL} size={40} />
          <Answer>{answer}</Answer>
        </CollapsibleDiv>
      </AnswerContainer>
    </Container>
  );
}
